module.exports = __webpack_public_path__ + "static/media/logostr3m.6fe2ec41.png";